import React, { useEffect, useState } from 'react'
import getName from './getName'
import blockMap from '../components/blocks'
import HeroBlock from '../components/HeroBlock/HeroBlock'

// Skeleton
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const BlockReturn = ({ blocks, serviceSettings, type }) => {
    let [clientSide, setClientSide] = useState(false)
    useEffect(() => {
        const isClientSide = typeof window !== 'undefined'
        if (isClientSide) setClientSide(true)
    }, [])

    return blocks?.map((block, index) => {
        // assign component match with name
        const Component =
            Object.keys(block).length === 0
                ? blockMap['fallback']
                : blockMap[getName(block?.name)]

        if (getName(block.name) === 'heroblock') {
            return <HeroBlock key={`${block?.name}-${index}`} {...block} />
        }

        return clientSide ? (
            <React.Suspense
                key={`${block?.name}-${index}`}
                fallback={<Skeleton count={20} />}
            >
                <Component
                    {...block}
                    serviceSettings={serviceSettings || {}}
                    type={type}
                />
            </React.Suspense>
        ) : null
    })
}

export default BlockReturn
